import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Input, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { Workspace } from '../../clients/aasServerClient.generated';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import { fetchTableWorkspaces,fetchTableWorkspacesNF } from '../../stores/workspaces/actionCreators';
import { getTableWorkspaces } from '../../stores/workspaces/selectors';
import ViewContainer from '../layout/ViewContainer';
import Table from '../table/Table';
import TableBody from '../table/TableBody';
import WorkspaceTableHead from './WorkspacesTableHead';
import WorkspaceTableRow from './WorkspacesTableRow';
import WorkspacesToolbar from './WorkspacesToolbar';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    workspaces: Workspace[];
    loading: boolean;
    fetchWorkspaces: () => void;
    fetchWorkspacesNF: () => void;
    lState : RootState;
}

export class WorkspacesPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);        
        this.props.lState.tables['workspaces'].search ='';
        this.props.fetchWorkspacesNF();
    }

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="table-view">
                <div>
                    <h1>{t('workspaces.header.workspaces')}</h1>
                    {this.props.loading ? <Spinner /> : null}
                </div>
                <Table
                    toolbar={<WorkspacesToolbar />}
                    refresh={this.props.fetchWorkspaces}
                    tableKey="workspaces"
                >
                    <WorkspaceTableHead
                        refresh={this.props.fetchWorkspaces}
                        ids={this.props.workspaces.map((u) => u.id)}
                    />
                    <TableBody>
                        {this.props.workspaces.map((workspace, i) => (
                            <WorkspaceTableRow key={i} workspace={workspace} />
                        ))}
                    </TableBody>
                </Table>
            </ViewContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    loading: isLoading(state),
    workspaces: getTableWorkspaces(state),
    lState : state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchWorkspaces: () => dispatch(fetchTableWorkspaces()),
    fetchWorkspacesNF: () => dispatch(fetchTableWorkspacesNF()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(WorkspacesPage)));
